export default "__VITE_PUBLIC_ASSET__4e39dcb8__"